import { useDesignItemsFromSolutionConfigurationCalculation } from '@/resources/solutionConfiguration/solutionConfigurationHandler';
import { compareByString } from '@luminovo/commons';
import React from 'react';
import { ViewCommentsButton, useCommunicationsDrawer } from '../../../../components/CommentsDrawer';
import { DesignItemPath } from '../../../Sourcing/components/SolutionConfigurations/SolutionConfigurationTypes';

export const SolutionManagerCommentsButton = React.memo(function SolutionManagerCommentsButton({
    rfqId,
    solutionConfigId,
    iconButtonOnly,
    size,
}: {
    rfqId: string;
    solutionConfigId: string;
    iconButtonOnly?: boolean;
    size?: 'small' | 'medium' | 'large';
}) {
    const { designItemPaths } = useDesignItemsFromSolutionConfigurationCalculation(solutionConfigId);

    const { openDrawer } = useCommunicationsDrawer({
        threads: (designItemPaths ?? []).flatMap((designItemPath) => {
            const parentAssemblies = designItemPath.path;
            const designators = designItemPath.designators.sort(compareByString).join(', ');

            return [
                {
                    commentType: 'DesignItem',
                    category: 'Internal',
                    typeIds: designItemPath.designItemIds,
                    group: {
                        label: `${parentAssemblies} > ${designators}`,
                        groupId: designItemPath.assemblyId,
                    },
                    rfqId,
                },
                {
                    commentType: 'DesignItem',
                    category: 'Public',
                    typeIds: designItemPath.designItemIds,
                    group: {
                        label: `${parentAssemblies} > ${designators}`,
                        groupId: designItemPath.assemblyId,
                    },
                    rfqId,
                },
            ];
        }),
    });

    return (
        <ViewCommentsButton
            eventEntity={{
                type: 'DesignItem',
                data: designItemPaths?.flatMap((designItemPath) => designItemPath.designItemIds) ?? [],
            }}
            onClick={() => openDrawer()}
            iconButtonOnly={iconButtonOnly}
            size={size}
        />
    );
});

export const SolutionConfigurationCommentsButton = React.memo(function SolutionManagerCommentsButton({
    rfqId,
    designItemIds,
    designItemPaths,
    iconButtonOnly,
    size,
}: {
    rfqId: string;
    designItemIds: string[];
    designItemPaths: DesignItemPath[];
    iconButtonOnly?: boolean;
    size?: 'small' | 'medium' | 'large';
}) {
    const { openDrawer } = useCommunicationsDrawer({
        threads: designItemPaths.flatMap((designItemPath) => {
            const assemblyPath = designItemPath.path;
            const designators = designItemPath.designators.sort(compareByString).join(', ');

            const designItemIds = designItemPath.designItemIds;

            return [
                {
                    rfqId,
                    commentType: 'DesignItem',
                    category: 'Internal',
                    typeIds: designItemIds,
                    group: {
                        label: `${assemblyPath} > ${designators}`,
                        groupId: assemblyPath,
                    },
                },
                {
                    rfqId,
                    commentType: 'DesignItem',
                    category: 'Public',
                    typeIds: designItemIds,
                    group: {
                        label: `${assemblyPath} > ${designators}`,
                        groupId: assemblyPath,
                    },
                },
            ];
        }),
    });

    return (
        <ViewCommentsButton
            eventEntity={{ type: 'DesignItem', data: designItemIds }}
            onClick={() => openDrawer()}
            iconButtonOnly={iconButtonOnly}
            size={size}
        />
    );
});
